import React from 'react'

import { colors } from 'helpers/colors'

function SvgBellOutline({ size = 30, color = colors.gray[700] }) {
  return (
    <svg height={size} viewBox="0 0 26 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.3752 26.5C17.3752 27.6935 16.9142 28.8381 16.0938 29.682C15.2733 30.5259 14.1605 31 13.0002 31C11.8399 31 10.7272 30.5259 9.90669 29.682C9.08624 28.8381 8.62531 27.6935 8.62531 26.5M14.0517 5.50453L11.9138 5.50003C7.03721 5.48803 2.80374 9.56353 2.7702 14.5V20.185C2.7702 21.37 2.62437 22.5265 1.99584 23.512L1.57731 24.169C0.940025 25.165 1.62543 26.5 2.7702 26.5H23.2303C24.375 26.5 25.059 25.165 24.4232 24.169L24.0046 23.512C23.3776 22.5265 23.2303 21.3685 23.2303 20.1835V14.5015C23.1719 9.56353 18.9283 5.51653 14.0517 5.50453V5.50453Z"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9999 1C13.7734 1 14.5153 1.31607 15.0622 1.87868C15.6092 2.44129 15.9165 3.20435 15.9165 4V5.5H10.0833V4C10.0833 3.20435 10.3905 2.44129 10.9375 1.87868C11.4845 1.31607 12.2263 1 12.9999 1Z"
        stroke={color}
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgBellOutline
